import type { AxiosError } from 'axios';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type { TranscribeRT } from '@/types';

type Props = {
  tagSummaryId: number;
} & IProjectId;
type Data = {
  citations: TranscribeRT.ProjectTaggedMoment[];
};
type QueryKey = readonly [string, Props];

type Options = UseQueryOptions<Data, AxiosError, Data, QueryKey>;

export const useFetchProjectTagSummaryCitations = (props: Props, options?: Options) => {
  const api = useChatApiClient();

  return useQuery({
    queryKey: ['get:projects/conference-tags/summaries/citations', props] as const, queryFn: ({ queryKey }) => {
      const [, { projectId, tagSummaryId }] = queryKey;
      return api.projects.getTagSummaryCitations({
        projectId,
        tagSummaryId,
      });
    },
    enabled: !!props.tagSummaryId,
    initialData: {
      citations: [],
    },
    ...options,
  });
};